module.exports = __webpack_public_path__ + "static/media/icon_status_before.ba9ee715.svg";